import { useState } from 'react';

const SalesDepartmentModel = () => {
  const initialState = {
    id: '',
    salesDepartmentName: '',
  };

  const [salesDepartment, setSalesDepartment] = useState(initialState);

  return { salesDepartment, setSalesDepartment, initialState };
};

export default SalesDepartmentModel;
